// 会员卡
const confirmBuyCard = {
  namespaced: true,
  state: {
    // 会员卡信息
    cardInfo: {}
  },
  mutations: {
    setCardInfo (state, payload) {
      state.cardInfo = payload
    }
  },
  actions: {
    setCardInfo (context, payload) {
      context.commit('setCardInfo', payload)
    }
  }
}

export default confirmBuyCard



// WEBPACK FOOTER //
// ./src/store/card/confirmBuyCard.js